module.exports = __webpack_public_path__ + "img/BS-PD.71eff282.png";